import { defineComponent, ref, Ref, computed, onMounted, watch } from 'vue';
import { BannerModel, BannerStatus } from '@truckdown/locations';
import { isCsrOrAdmin, showMessage } from '../../../Utilities/utilities';
import { IAnalyticsDataBrowser } from '@truckdown/analysis/Analytics/IAnalyticsDataBrowser';
import { AnalyticDataModel } from '@truckdown/analysis/Analytics/AnalyticDataModel';
import { DrilledAnalyticQueryModel } from '@truckdown/analysis/Analytics/DrilledAnalyticQueryModel';
import { DataPeriod } from '@truckdown/analysis/Analytics/DataPeriod';
import context from '@truckdown/systems';

interface IProps {
    banner: BannerModel;
    analytics: any;
}

interface IData {
    analyticsData: Ref<AnalyticDataModel[]>,
    model: Ref<DrilledAnalyticQueryModel>
}

const getData = function (props: IProps): IData {
    return {
        analyticsData: ref<any>(props.analytics),
        model: ref<DrilledAnalyticQueryModel>({
            name: "bv",
            value: props.banner.id,
            cube: "banner",
            period: DataPeriod.Month,
            start: new Date(new Date().setMonth(new Date().getMonth() - 6)),
            end: new Date(),
        })
    }
}

const getMethods = function (props: IProps, data: IData, ctx: any) {
    return {
        onlyMonth: function (dateString: string): string | undefined {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return undefined;
            }
            const utcYear = date.getUTCFullYear();
            const utcMonth = date.getUTCMonth();
            const utcDate = Date.UTC(utcYear, utcMonth, 1);
            const options = { month: 'long', year: 'numeric', timeZone: 'UTC' } as any;
            return new Intl.DateTimeFormat('en-US', options).format(utcDate);
        },
    }
}

const getComputed = function (props: any, data: IData) {

    return {
        isAdmin: computed(() => {
            return isCsrOrAdmin();
        })
    };
}

const getAnalyticsData = async function (data: IData) {
    try {
        //const service = await context.getService<IAnalyticsDataBrowser>('IAnalyticsDataBrowser');
        //const result = await service.drilledQuery(data.model.value)
        //if (result !== null) {
        //    data.analyticsData.value = result;
        //}
    } catch (reason) {
        console.error('Error getting services', reason);
    }
};

export default defineComponent({
    name: "BannerAnalytics",
    props: {
        banner: {
            type: Object as () => BannerModel,
            required: true
        },
        analytics: Object
    },
    setup: function (props, ctx) {
        let data = getData(props);
        let computed = getComputed(props, data);
        let methods = getMethods(props, data, ctx);


        onMounted(async () => {
            await getAnalyticsData(data);
        });

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});